import { render, staticRenderFns } from "./b-btn.vue?vue&type=template&id=5d4729b9&scoped=true&"
import script from "./b-btn.vue?vue&type=script&lang=js&"
export * from "./b-btn.vue?vue&type=script&lang=js&"
import style0 from "./b-btn.vue?vue&type=style&index=0&id=5d4729b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4729b9",
  null
  
)

export default component.exports